import dayjs from 'dayjs';
export const DEFAULT_WORK_ORDER_DASHBOARD_PRESET_ID = 'last-6-months';
export const THIS_MONTH_WORK_ORDER_DASHBOARD_PRESET_ID = 'this-month';
export const CUSTOM_WORK_ORDER_DASHBOARD_PRESET_ID = 'custom';
export const ALL_TIME_WORK_ORDER_DASHBOARD_PRESET_ID = 'all-time';
// Quarter boundaries: Q1=Jan-Mar, Q2=Apr-Jun, Q3=Jul-Sep, Q4=Oct-Dec
// month is 0-indexed from dayjs/JS Date
function quarterStart(d) {
    const quarterFirstMonth = Math.floor(d.month() / 3) * 3;
    return d.month(quarterFirstMonth).startOf('month');
}
function quarterEnd(d) {
    const quarterFirstMonth = Math.floor(d.month() / 3) * 3;
    return d.month(quarterFirstMonth + 2).endOf('month');
}
export const WORK_ORDER_DASHBOARD_PRESETS = [
    {
        id: ALL_TIME_WORK_ORDER_DASHBOARD_PRESET_ID,
        label: 'All time',
        compute: () => ({ start: null, end: null })
    },
    {
        id: THIS_MONTH_WORK_ORDER_DASHBOARD_PRESET_ID,
        label: 'This month',
        compute: () => {
            const now = dayjs();
            return { start: now.startOf('month').toDate(), end: now.endOf('month').toDate() };
        }
    },
    {
        id: 'last-month',
        label: 'Last month',
        compute: () => {
            const lastMonth = dayjs().subtract(1, 'month');
            return { start: lastMonth.startOf('month').toDate(), end: lastMonth.endOf('month').toDate() };
        }
    },
    {
        id: 'this-quarter',
        label: 'This quarter',
        compute: () => {
            const now = dayjs();
            return { start: quarterStart(now).toDate(), end: quarterEnd(now).toDate() };
        }
    },
    {
        id: 'last-quarter',
        label: 'Last quarter',
        compute: () => {
            const lastQuarterMonth = dayjs().subtract(3, 'month');
            return {
                start: quarterStart(lastQuarterMonth).toDate(),
                end: quarterEnd(lastQuarterMonth).toDate()
            };
        }
    },
    {
        id: 'last-90-days',
        label: 'Last 90 days',
        // today − 89 days (startOfDay) → today (endOfDay) = 90 days inclusive
        compute: () => {
            const now = dayjs();
            return {
                start: now.subtract(89, 'day').startOf('day').toDate(),
                end: now.endOf('day').toDate()
            };
        }
    },
    {
        id: DEFAULT_WORK_ORDER_DASHBOARD_PRESET_ID,
        label: 'Last 6 months',
        // rolling trailing 180 days: today − 180 days (startOfDay) → today (endOfDay)
        compute: () => {
            const now = dayjs();
            return {
                start: now.subtract(180, 'day').startOf('day').toDate(),
                end: now.endOf('day').toDate()
            };
        }
    },
    {
        id: 'year-to-date',
        label: 'Year to date',
        // Jan 1 this year → today (not Dec 31)
        compute: () => {
            const now = dayjs();
            return { start: now.startOf('year').toDate(), end: now.endOf('day').toDate() };
        }
    },
    {
        id: 'last-year',
        label: 'Last year',
        compute: () => {
            const lastYear = dayjs().subtract(1, 'year');
            return { start: lastYear.startOf('year').toDate(), end: lastYear.endOf('year').toDate() };
        }
    },
    // Custom must be last — DateRangeFilter activates calendar when this preset is clicked.
    // compute() returns null boundaries; the actual range comes from user-picked calendar dates.
    {
        id: CUSTOM_WORK_ORDER_DASHBOARD_PRESET_ID,
        label: 'Custom',
        compute: () => ({ start: null, end: null })
    }
];
export function getPresetById(id) {
    const found = WORK_ORDER_DASHBOARD_PRESETS.find((p) => p.id === id);
    return (found !== null && found !== void 0 ? found : WORK_ORDER_DASHBOARD_PRESETS.find((p) => p.id === DEFAULT_WORK_ORDER_DASHBOARD_PRESET_ID));
}
